import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useRillContext } from "../../rill/RillReact/share/base";
import { formatExerciseDisplay } from "../../utils/metcon";
import { getExerciseName } from "../modals/learn-more/blockHelpers";
import StatusIcon from "../StatusIcon";

const MetconExercisesList = ({
  exercise,
  setIndex,
  showCompletion = false,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  if (
    !exercise ||
    exercise.primary !== "metcon" ||
    !exercise.sets?.length ||
    setIndex > 0
  ) {
    return null;
  }

  // A metcon completes as a whole (result lives in metconResult, not per-movement),
  // so every movement row reflects the same completed state.
  const metconStatus = exercise.metconResult?.status;
  const isCompleted = metconStatus === "completed";

  return (
    <div className="metcon-exercises-list">
      <p className="p5 exercises-header">
        {t("metconExercisesList.exerciseName")}
      </p>
      <div className="exercises-container">
        {exercise.sets.map((set, index) => {
          const exerciseName =
            getExerciseName({
              primary: set.primary,
              secondary: set.exercise,
              type: set.type,
            }) || set.exercise;

          const parameters = formatExerciseDisplay(set, locals);

          return (
            <div
              key={`${exercise._id}-${index}`}
              className={`exercise-row${
                showCompletion && isCompleted ? " completed" : ""
              }`}
            >
              {showCompletion && metconStatus && (
                <span
                  className={`wk-status-inline exercise-check${
                    isCompleted ? " completed" : ""
                  }`}
                >
                  <StatusIcon status={metconStatus} />
                </span>
              )}
              <p className="p4 exercise-name">{exerciseName}</p>
              {parameters && (
                <p className="p4 exercise-parameters">{parameters}</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

MetconExercisesList.contextTypes = { locals: PropTypes.object };

MetconExercisesList.propTypes = {
  exercise: PropTypes.object,
  setIndex: PropTypes.number,
  showCompletion: PropTypes.bool,
};

export default MetconExercisesList;
